import { Button, Icon, Pagination, Link, TextField, Page, EmptyState, Modal, FooterHelp, Badge, Card, BlockStack, InlineStack, Text, Tabs, Box, FormLayout, Select, ChoiceList, Tooltip } from '@shopify/polaris';
import { DI, DIProps } from '../../../../Core';
import NoResultsFound from '../../../../Asests/Images/NoResultsFound.png'
import { SearchMinor, CircleInformationMajor, DropdownMinor } from '@shopify/polaris-icons';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Table } from 'antd';
import { RenderHeadersAction } from '../../Panel';
import { syncConnectorInfo } from '../../../../Actions';
import { useDebounce } from '../../useDebounce';
import FullfillmentSkeleton from '../skeleton/FullfillmentSkeleton';
import { amazon_regions } from '../../Onboarding/components/onboardinghelper';
import DownloadLabel from './DownloadLabel';
import { ViewIcon } from './SVGs';
import { countryWithDemonym } from '../..';
import { isAdminLoggedIn } from '../../Panel/index';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

function AllSales(props: Props) {
    const { t } = useTranslation();
    const country = countryWithDemonym[props?.redux?.current?.target?.warehouses?.[0]?.marketplace_id].country

    const allOrdersColumns = [
        {
            title: t('Amazon Order Id'),
            dataIndex: 'id',
            width: '150px',
        },
        {
            title: t('Shopify Order Id'),
            dataIndex: 'shopify_order_id',
            width: '150px',
        },
        {
            title: t('Fulfilment Status'),
            dataIndex: 'shipping_status',
            width: '150px',
        },
        {
            title: t('Ordered Items'),
            dataIndex: 'ordered_items',
            width: '150px',
        },
        {
            title: t('Total Price'),
            dataIndex: 'total_price',
            width: '150px',
        },
        {
            title: t('Shipment Error'),
            dataIndex: 'error_status',
            width: '150px',
        },
        {
            title: t('Reason'),
            dataIndex: 'shipping_error',
            width: '150px',
        },
        {
            title: t('Created At'),
            dataIndex: 'created_at',
            width: '150px',
        },
        // ...(['FR', 'IN', 'IT', 'ES', 'GB', 'US'].includes(country) ? [
        //     {
        //         title: 'Buy Shipping',
        //         dataIndex: 'buy_shipping',
        //         width: '150px',
        //     }
        // ] : []),
    ];

    const [clicks, setClicks] = useState<number>(0);
    const [fulfilmentType, setFulfilmentType] = useState<string>('FBM');
    const [totalPages, setTotalPages] = useState<number>(0);
    const [activePage, setActivePage] = useState<number>(1);
    const [pageCount, setpageCount] = useState<number>(10);
    const [inputValue, setInputValue] = useState('');
    const [gridRows, setGridRows] = useState<any>([]);
    const [importLoader, setImportLoader] = useState<boolean>(false)
    const [importOrderId, setImportOrderId] = useState<string>('');
    const [loader, setLoader] = useState<boolean>(true);
    const [importError, setimportError] = useState<boolean>(false);
    const [activateImportModal, setactivateImportModal] = useState<boolean>(false);
    const [showSkeleton, setShowSkeleton] = useState<boolean>(false);
    const [orderStatus, setorderStatus] = useState("all");
    const shippedOptions: any = [{ label: "All", value: "all" }, { label: "Shipped", value: "shipped" }, { label: "Unshipped", value: "unshipped" }, { label: "Error", value: "error" }];
    const prevInput = useRef('');
    const [rowLoader, setrowLoader] = useState(-1)

    const getUser = () => {
        let tempUser = props?.redux?.shop.split(".")[0];
        return tempUser;
    }

    const getShopifyOrderId = (obj: any): any => {
        let orderId = "";
        obj?.targets?.map((target: any) => {
            if (target?.marketplace == "shopify") {
                orderId = target?.order_id;
            }
        });
        return orderId;
    }

    const getShopifyShopUrl = (orderId: string) => {
        let shopUrl: string = "";
        if (orderId) {
            let user = getUser();
            shopUrl = `https://admin.shopify.com/store/${user}/orders/${orderId}`;
        }
        return shopUrl;
    }

    const getRows = (data: any) => {
        const rows: any = data.filter((ele: any) => ele['cif_order_id']).map((obj: any, index: number) => {
            let orderId = getShopifyOrderId(obj);
            let shopUrl = getShopifyShopUrl(orderId);
            let shipping_error = t("N/A");
            if (obj.shipment_error && obj.shipment_error[0]) {
                shipping_error = obj.shipment_error[0]
            }

            let row: any = {
                key: obj?.['cif_order_id'],
                id: obj?.['marketplace_reference_id'] ?? t("N/A"),
                shopify_order_id: shopUrl && shopUrl != "" ? <Link target='_blank' url={shopUrl}>{orderId}</Link> : t("N/A"),
                shipping_status: obj?.['shipping_status']?.toLowerCase() == "shipped" ? <Badge progress={'complete'}>{obj?.['shipping_status']}</Badge> : <Badge progress={'incomplete'} tone="attention">{t("Unshipped")}</Badge>,
                // shipping_status: shipping_error == t("N/A") ? (obj?.['shipping_status']?.toLowerCase() == "shipped" ? <Badge progress={'complete'}>{obj?.['shipping_status']}</Badge> : <Badge progress={'incomplete'} tone="attention">Unshipped</Badge>) : <BlockStack gap="200"><Badge progress={"incomplete"} tone="attention">Unshipped</Badge><Badge progress={"incomplete"} tone="critical">Shipment Error</Badge></BlockStack>,
                ordered_items: `${obj?.items?.length ?? 0} item(s)`,
                total_price: `${amazon_regions.find(a => a?.currency === (obj?.marketplace_currency ?? ''))?.['currency_symbol'] || ''} ${obj?.total?.marketplace_price ?? 0}`,
                created_at: obj?.['created_at']?.slice(0, 10) ?? t("N/A"),
                shipping_error: shipping_error,
                // buy_shipping:
                //     obj?.['shipping_status']?.toLowerCase() == "shipped" ? <InlineStack gap="400">
                //         <Tooltip content='Dowmnload your shipping label here'><DownloadLabel obj={obj} /></Tooltip>
                //         <Tooltip content='View shipment details'><Button
                // icon={ViewIcon}
                // onClick={() => { props.history('../buyShipping', { state: obj }) }}
                // removeUnderline
                // variant="monochromePlain" /></Tooltip>
                //     </InlineStack> :
                //         <Button
                //             onClick={() => { props.history('../buyShipping', { state: obj }) }}
                //             variant="primary">Buy Shipping</Button>,
                // error_status: shipping_error == "N/A" ? "N/A" : <Badge progress={"incomplete"} tone="critical">Error</Badge>

            };
            return row;
        });
        return rows;
    }

    const getAllOrders = async () => {
        setLoader(true);
        setShowSkeleton(false);
        let obj: any = { activePage: activePage, count: pageCount };
        if (inputValue && inputValue != "") {
            obj['filter[marketplace_reference_id][3]'] = inputValue;
        };
        if (inputValue !== prevInput.current && activePage !== 1) {
            obj.activePage = 1;
            setActivePage(1);
            return;
        }
        obj['filter[object_type][1]'] = "source_order";
        obj['filter[marketplace_shop_id][1]'] = props?.redux?.current?.target?._id;
        switch (orderStatus) {
            case "shipped":
                obj['filter[shipping_status][1]'] = "Shipped";
                break;
            case "unshipped":
                obj['filter[shipping_status][2]'] = "Shipped";
                break;
            case "error":
                obj['filter[shipping_status][2]'] = "Shipped";
                obj['filter[shipment_error][10]'] = true;
                break;
            default:
                break;
        }

        obj['filter[fulfilled_by][3]'] = fulfilmentType == "FBA" ? "other" : "merchant";
        let response = await props.di.GET('connector/order/getAll', obj);
        setLoader(false);
        if (response.success && response?.data?.rows?.length > 0) {
            let rows = getRows(response?.data?.rows);
            setGridRows(rows);
            setTotalPages(Math.ceil(response?.data?.['count'] / pageCount));
            setShowSkeleton(false);
        }
        else {
            setShowSkeleton(true);
            setGridRows([]);
        }
        prevInput.current = inputValue;
    }

    const handlePreviousPagination = () => {
        setActivePage(prev => prev - 1);
    }

    const handleNextPagination = () => {
        setActivePage(prev => prev + 1);
    }

    const customModal = (open: boolean, onClose: () => void, title: string, primaryAction: any, structure: any, secondaryActions: any) => {
        return <Modal
            open={open}
            onClose={onClose}
            title={title}
            primaryAction={primaryAction}
            secondaryActions={secondaryActions}
        >
            {structure && structure != "" &&
                <Modal.Section>
                    {structure}
                </Modal.Section>}
        </Modal>
    }

    const handleImportBtn = () => {
        setactivateImportModal(!activateImportModal);
    }

    const handleImportModalClose = () => {
        setactivateImportModal(!activateImportModal);
        setImportOrderId('');
        setimportError(false)
    }

    const handleImportModalChange = async () => {
        setImportLoader(true);
        let obj: any = {
            "source": { "marketplace": "shopify", "shopId": props?.redux?.current?.source?.['_id'] },
            "target": {
                "marketplace": "amazon", "shopId": props?.redux?.current?.target?.['_id']
            },
            "source_order_ids": importOrderId
        }
        if (importOrderId && importOrderId != "" && importOrderId.trim().length > 0) {
            let response = await props.di.POST('connector/order/importOrder', obj);
            setImportLoader(false);
            if (response.success) {
                props.success(t("Order imported successfully."));
                getAllOrders();
            }
            else {
                props.error(t(response?.message) ?? t("Oops! Some error occured."))
                setImportOrderId('');
            }
            setactivateImportModal(!activateImportModal);
        }
        else {
            props.error(t("Kindly fill Amazon order id to proceed importing of orders."))
            setImportLoader(false);
            setimportError(true);
        }
    };

    const handleFulfilmentChange = () => {
        setClicks((prev) => prev + 1);
    }

    useEffect(() => {
        if (clicks % 2 == 0) {
            setFulfilmentType('FBM');
        }
        else setFulfilmentType('FBA');
    }, [clicks])

    const debouncedValue = useDebounce(inputValue, 500);
    useEffect(() => {
        getAllOrders();
        // }, [activePage, debouncedValue, fulfilmentType]);
    }, [activePage, debouncedValue, orderStatus, fulfilmentType]);
    // }, [activePage, debouncedValue, orderStatus]);

    // const handleOrderStatus = (value: string) => {
    //     setorderStatus(value);
    //     getAllOrders()
    // };

    // useEffect(() => {
    //     getAllOrders()
    // }, [orderStatus])

    const [selected, setSelected] = useState(0);

    const handleTabChange = useCallback(
        (selectedTabIndex: number) => setSelected(selectedTabIndex),
        []
    );
    const tableref = useRef<HTMLTableElement>(document.createElement("table"));
    const [selectedRows, setselectedRows] = useState<Array<string>>([]);
    const [DataforRow, setDataforRow] = useState<Array<any>>([]);
    //useEffect for hiding the table heading
    useEffect(() => {
        if (selectedRows.length > 0) {
            tableref.current?.classList.add("header-hidden");
        } else {
            tableref.current?.classList.remove("header-hidden");
        }
    }, [selectedRows]);

    const tabs = [
        {
            id: "all",
            content: "All",
            subcontent: <BlockStack gap="200">
                {showSkeleton ? <InlineStack align="center" gap="400">
                    <EmptyState
                        image={NoResultsFound}
                        heading={t("No Orders Found")}
                    />
                </InlineStack> :
                    (<>
                        {!loader ? (
                            <Table
                                columns={allOrdersColumns}
                                dataSource={gridRows}
                                scroll={{ x: 768 }}
                                pagination={false}
                                loading={loader}
                                size='middle'
                            />
                        ) : (<FullfillmentSkeleton />)
                        }</>)
                }
                {gridRows.length > 0 &&

                    <InlineStack align="center" gap="400">
                        <Pagination
                            label={`${activePage}/${totalPages}`}
                            hasPrevious={activePage > 1 && !loader}
                            onPrevious={() => {
                                handlePreviousPagination()
                            }}
                            hasNext={activePage < totalPages && !loader}
                            onNext={() => {
                                handleNextPagination()
                            }}
                        />
                    </InlineStack>
                }
            </BlockStack>,
        },
        {
            id: "shipped",
            content: "Shipped",
            subcontent:
                <BlockStack gap="200">
                    {showSkeleton ? <InlineStack align="center" gap="400">
                        <EmptyState
                            image={NoResultsFound}
                            heading={t("No Orders Found")}
                        />
                    </InlineStack> :
                        (<>
                            {!loader ? (
                                <Table
                                    columns={allOrdersColumns}
                                    dataSource={gridRows}
                                    scroll={{ x: 768 }}
                                    pagination={false}
                                    loading={loader}
                                    size='middle'
                                />
                            ) : (<FullfillmentSkeleton />)
                            }</>)
                    }
                    {gridRows.length > 0 &&
                        <InlineStack align="center" gap="400">
                            <Pagination
                                label={`${activePage}/${totalPages}`}
                                hasPrevious={activePage > 1 && !loader}
                                onPrevious={() => {
                                    handlePreviousPagination()
                                }}
                                hasNext={activePage < totalPages && !loader}
                                onNext={() => {
                                    handleNextPagination()
                                }}
                            />
                        </InlineStack>
                    }
                </BlockStack>,
        },
        {
            id: "unshipped",
            content: "Unshipped",
            subcontent:
                <BlockStack gap="200">
                    {showSkeleton ? <InlineStack align="center" gap="400">
                        <EmptyState
                            image={NoResultsFound}
                            heading={t("No Orders Found")}
                        />
                    </InlineStack> :
                        (<>
                            {!loader ? (
                                <Table
                                    columns={allOrdersColumns}
                                    dataSource={gridRows}
                                    scroll={{ x: 768 }}
                                    pagination={false}
                                    loading={loader}
                                    size='middle'
                                />
                            ) : (<FullfillmentSkeleton />)
                            }</>)
                    }
                    {gridRows.length > 0 &&
                        <InlineStack align="center" gap="400">
                            <Pagination
                                label={`${activePage}/${totalPages}`}
                                hasPrevious={activePage > 1 && !loader}
                                onPrevious={() => {
                                    handlePreviousPagination()
                                }}
                                hasNext={activePage < totalPages && !loader}
                                onNext={() => {
                                    handleNextPagination()
                                }}
                            />
                        </InlineStack>
                    }
                </BlockStack>,
        },
        // {
        //     id: "unshipped",
        //     content: "Unshipped",
        //     subcontent: <BlockStack gap="200">
        //         {showSkeleton ? <InlineStack align="center" gap="400">
        //             <EmptyState
        //                 image={NoResultsFound}
        //                 heading={"No Orders Found"}
        //             />
        //         </InlineStack> :
        //             (<>
        //                 {!loader ? (
        //                     <div className='Custom-Alpha-Card'>
        //                         <Modal
        //                             large
        //                             open={active}
        //                             onClose={handleChange}
        //                             title="Buy Shipping in bulk"
        //                             primaryAction={{
        //                                 content: 'Buy Shipment',
        //                                 onAction: handleChange,
        //                             }}
        //                             secondaryActions={[
        //                                 {
        //                                     content: 'Close',
        //                                     onAction: handleChange,
        //                                 },
        //                             ]}
        //                         >
        //                             <Modal.Section>
        //                                 <Table
        //                                     columns={BuyShippingColumn}
        //                                     dataSource={BuyShippingDataSource}
        //                                     scroll={{ x: 900 }}
        //                                     pagination={false}
        //                                     size='middle'
        //                                     bordered
        //                                     footer={() => <InlineStack gap="400">
        //                                         <TextField
        //                                             label="Ship From"
        //                                             autoComplete="off"
        //                                         />
        //                                         <TextField
        //                                             label="Ship Date"
        //                                             type="date"
        //                                             autoComplete="off"
        //                                         />
        //                                     </InlineStack>}
        //                                 />

        //                             </Modal.Section>
        //                         </Modal>
        //                         <Table
        //                             ref={tableref}
        //                             sticky
        //                             columns={UnshippedOrderColumn}
        //                             dataSource={dataSource}
        //                             scroll={{ x: 768 }}
        //                             pagination={false}
        //                             loading={loader}
        //                             size='middle'
        //                             rowSelection={{
        //                                 onSelect: (value) => {
        //                                     let temp = [...selectedRows];
        //                                     if (temp.includes(value?.key)) {
        //                                         temp.splice(temp.indexOf(value['key']), 1);
        //                                     } else temp.push(value['key']);
        //                                     setselectedRows([...temp]);
        //                                 },
        //                                 onSelectAll: (value, rows) => {
        //                                     let temp: Array<any> = [];
        //                                     rows.forEach((row) => {
        //                                         temp.push(row?.key);
        //                                     });
        //                                     setselectedRows([...temp]);
        //                                 },
        //                                 selectedRowKeys: selectedRows,
        //                             }}
        //                             summary={() => (
        //                                 selectedRows.length > 0 ? (
        //                                     <Table.Summary fixed="top">
        //                                         <Table.Summary.Row>
        //                                             <Table.Summary.Cell index={0} colSpan={5}>
        //                                                 <div
        //                                                     className='toolbar'
        //                                                     style={{
        //                                                         backgroundColor: '#fafafa',
        //                                                     }}>

        //                                                     <InlineStack gap="400" blockAlign="center" align="start">
        //                                                         <ButtonGroup variant="segmented">
        //                                                             <Button
        //                                                                 size="slim"
        //                                                                 icon={
        //                                                                     <Checkbox
        //                                                                         onChange={(value) => {
        //                                                                             console.log({ value })
        //                                                                         }}
        //                                                                         checked={
        //                                                                             selectedRows.length <
        //                                                                                 DataforRow.length
        //                                                                                 ? 'indeterminate'
        //                                                                                 : true
        //                                                                         }
        //                                                                         label={
        //                                                                             undefined
        //                                                                         }></Checkbox>
        //                                                                 }
        //                                                                 loading={false}>
        //                                                                 {selectedRows.length.toString()} {' '} order selected
        //                                                             </Button>
        //                                                             <Button
        //                                                                 onClick={() => { setselectedRows([]) }} size="medium" icon={MobileCancelMajor}></Button>
        //                                                         </ButtonGroup>
        //                                                         <Button variant='primary'onClick={handleChange}>Buy Shipment</Button>
        //                                                     </InlineStack>
        //                                                 </div>
        //                                             </Table.Summary.Cell>
        //                                         </Table.Summary.Row>
        //                                     </Table.Summary>
        //                                 ) : null
        //                             )}
        //                         />
        //                     </div>
        //                 ) : (<FullfillmentSkeleton />)
        //                 }</>)
        //         }
        //         {gridRows.length > 0 &&
        //             <InlineStack align="center" gap="400">
        //                 <Pagination
        //                     label={`${activePage}/${totalPages}`}
        //                     hasPrevious={activePage > 1 && !loader}
        //                     onPrevious={() => {
        //                         handlePreviousPagination()
        //                     }}
        //                     hasNext={activePage < totalPages && !loader}
        //                     onNext={() => {
        //                         handleNextPagination()
        //                     }}
        //                 />
        //             </InlineStack>
        //         }
        //     </BlockStack>,
        // },
        {
            id: "error",
            content: "Error",
            subcontent:
                <BlockStack gap="200">
                    {showSkeleton ? <InlineStack align="center" gap="400">
                        <EmptyState
                            image={NoResultsFound}
                            heading={t("No Orders Found")}
                        />
                    </InlineStack> :
                        (<>
                            {!loader ? (
                                <Table
                                    columns={allOrdersColumns}
                                    dataSource={gridRows}
                                    scroll={{ x: 768 }}
                                    pagination={false}
                                    loading={loader}
                                    size='middle'
                                />
                            ) : (<FullfillmentSkeleton />)
                            }</>)
                    }
                    {gridRows.length > 0 &&
                        <InlineStack align="center" gap="400">
                            <Pagination
                                label={`${activePage}/${totalPages}`}
                                hasPrevious={activePage > 1 && !loader}
                                onPrevious={() => {
                                    handlePreviousPagination()
                                }}
                                hasNext={activePage < totalPages && !loader}
                                onNext={() => {
                                    handleNextPagination()
                                }}
                            />
                        </InlineStack>
                    }
                </BlockStack>,
        }
    ];

    return (
        <Page
            backAction={props?.match?.from !== "failed" ? {
                content: t("Failed Orders"),
                onAction: () => {
                    props.history('../home');
                },
            } : undefined}
            primaryAction={
                <RenderHeadersAction {...props} />
            }
            title={t("Fulfilment")}
            subtitle={t("This section allows you to see the fulfilment status of all your Amazon orders. To make changes into the fulfilment of these Amazon orders, you will have to do so from the Shopify panel.")}
            fullWidth
        >
            {customModal(activateImportModal, handleImportModalClose, t("Import Order(s)"), {
                content: t('Confirm'),
                onAction: handleImportModalChange,
                loading: importLoader
            }, <TextField error={importError} value={importOrderId} onChange={(e) => { setImportOrderId(e); setimportError(e == "") }} autoComplete="off" placeholder={t('Enter Amazon Order Id')} label={t("Amazon order id:")}></TextField>, [
                {
                    content: t('Cancel'),
                    onAction: handleImportModalClose,
                    disabled: importLoader
                },
            ])}
            <InlineStack gap="200">
                <Text as='h2' variant='headingMd'>{t("Fulfilment Type")} :</Text>
                <div onClick={handleFulfilmentChange} style={{ cursor: 'pointer' }}>
                    <InlineStack gap="100">
                        <Text as='h2' variant='headingMd'>{fulfilmentType}</Text>
                        <Icon source={DropdownMinor} accessibilityLabel={fulfilmentType}></Icon>
                    </InlineStack>
                </div>
            </InlineStack>
            <Card roundedAbove='sm' padding="0">
                <Tabs tabs={tabs} selected={selected} onSelect={(e) => {
                    setActivePage(1)
                    setorderStatus(tabs[e].id)
                    handleTabChange(e)
                }} />
                <Box padding="500">
                    <BlockStack gap="200">
                        <InlineStack gap="400" wrap={false}>
                            <div className='Custom-Stack-Item--fill'>
                                <TextField
                                    autoComplete='off'
                                    prefix={<div><Icon source={SearchMinor} tone="base" /></div>}
                                    label=""
                                    value={inputValue}
                                    onChange={(e) => {
                                        e = e.toString().replace(/[!$%^&*()@+|~=`\\#{}\[\]:";'<>?,.\/_]/gi, "");
                                        e = e.toString().replace("--", "-");
                                        setInputValue(e)
                                    }}
                                    clearButton
                                    onClearButtonClick={() => setInputValue('')}
                                    placeholder="Search with Amazon Order Id"
                                />
                            </div>
                            {/* <Text as="h3">Order Status Filter</Text> */}
                            {/* <Select label="Order Status Filter" options={shippedOptions} value={orderStatus} onChange={(e) => setorderStatus(e)} /> */}
                            <Button onClick={handleImportBtn}>{t("Import Orders")}</Button>
                        </InlineStack>
                        {tabs[selected].subcontent}
                    </BlockStack>
                </Box>
            </Card>

            <FooterHelp>
                <InlineStack align="center" gap="100">
                    <div>
                        <Icon
                            source={CircleInformationMajor}
                            tone="info"
                        />
                    </div>{t("Learn more about")}<Link target='_blank' url="https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=failed_orders">
                        {t("CedCommerce Amazon Channel")}
                    </Link>,<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                        {t("Terms & Conditions")}
                    </Link>and<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                       {t(" Data Privacy Rights.")}
                    </Link> Need Help?<Link target='_blank'
                        url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>
                        {t("Get Support")}
                    </Link>or<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                        Book a Call
                    </Link>
                </InlineStack>
            </FooterHelp>
        </Page >
    );
}

export default DI(AllSales, {
    func: {
        syncConnectorInfo,
    },
});
